/**
 * Configuración central para la aplicación
 * En producción usa rutas relativas para aprovechar el proxy inverso de Coolify
 * En desarrollo usa la URL completa del servidor local
 */
const config = {
  apiUrl: process.env.NODE_ENV === 'production'
    ? (process.env.REACT_APP_API_URL || '') // Permitir configurar URL en producción para debugging
    : (process.env.REACT_APP_API_URL || 'http://localhost:5678')
};

export default config; 